/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_AssigneeInputs */

const cs_form_assignee = /** @type {(inputs: Form_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazeno`)
};

const en_form_assignee = /** @type {(inputs: Form_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Form_AssigneeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_assignee = /** @type {((inputs?: Form_AssigneeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_AssigneeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_assignee(inputs)
	return cs_form_assignee(inputs)
});